<template>
  <m-board :title="$t('account.profile.personal-info.title')">
    <div class="profile-info">
      <div class="row" v-for="(item, i) in info" :key="i">
        <div class="name">{{ item.name }}:</div>
        <div class="value" v-if="item.value === 'Да' || item.value === 'Yes' || item.value === 'Bəli'" style="color: green;">{{ item.value }}</div>
        <div class="value" v-if="item.value === 'Нет' || item.value === 'No' || item.value === 'Yox'" style="color: red;">{{ item.value }}</div>
        <div class="value" v-if="item.value !== 'Нет' && item.value !== 'No' && item.value !== 'Yox' && item.value !== 'Да' && item.value !== 'Yes' && item.value !== 'Bəli'">{{ item.value }}</div>
      </div>
    </div>
  </m-board>
</template>

<script>
import MBoard from '@/components/MBoard'
import { mapState } from 'vuex'

export default {
  components: { MBoard },
  computed: {
    ...mapState({
      info: state => state.account.profile.info
    })
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('account/GET_PROFILE')
    }
  }
}
</script>

<style scoped>
.profile-info { display: flex; flex-direction: column; justify-content: center; padding: 10px 20px; }
.profile-info .row { display: flex; }
.profile-info .row:not(:first-child) { margin-top: 5px; }
.profile-info .name { padding-right: 8px; text-align: right; width: 50%; }
.profile-info .value { padding-left: 8px; }
</style>



// WEBPACK FOOTER //
// src/components/account/profile/Profile.vue